export default __webpack_public_path__ + "static/survey-start-43d9e4472d3a16a45a71aa7c48c6eea1.jpg";